export default __webpack_public_path__ + "static/media/application-logo.c45ab33b.png";